


















































































import { CashBackModalVue } from "fs-pb-vue2/vueModels/cardOperations/CashBackModalVue";
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class CashBackModal extends CashBackModalVue {
  
  isVisible = false;

  toggle() {
    this.isVisible = !this.isVisible;
  }

}
